import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const LastPass: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={size ?? '24px'} height={size ?? '24px'} viewBox="0 0 2 2" data-testid="lastpass-icon">
      <g>
        <path fill={color ?? '#D32D27'} d="M.3 0h1.4c.167 0 .3.133.3.3v1.4c0 .167-.133.3-.3.3H.3a.298.298 0 01-.3-.3V.3C0 .134.133 0 .3 0zm0 0" />
        <path
          fill={color ? secondaryColor || theme.palette.primary.main : '#FFF'}
          d="M.594 1a.173.173 0 01-.172.172A.173.173 0 01.25 1C.25.906.328.828.422.828.516.828.594.906.594 1zm0 0M1.059 1a.173.173 0 01-.172.172A.173.173 0 01.715 1c0-.094.078-.172.172-.172.093 0 .172.078.172.172zm0 0M1.527 1a.173.173 0 01-.172.172A.173.173 0 011.184 1c0-.094.078-.172.171-.172.094 0 .172.078.172.172zm0 0M1.71.625c.024 0 .04.02.04.04v.67a.04.04 0 01-.04.04.04.04 0 01-.038-.04v-.67c0-.02.016-.04.039-.04zm0 0"
        />
      </g>
    </svg>
  );
};

export default LastPass;
